import { DayDetailRequest } from './ReportingPage';


const TimelineView = ({ dayDetailRequests }: { dayDetailRequests: DayDetailRequest[] }) => {
        
  // Day detail helper functions
  const generateHourlyTimeline = () => {
    const hours = [];
    for (let hour = 0; hour < 24; hour++) {
      hours.push({
        hour,
        label: `${hour.toString().padStart(2, '0')}:00`,
        requests: dayDetailRequests.filter(request => {
          const startHour = new Date(request.startDateTime).getHours();
          const endHour = new Date(request.endDateTime).getHours();
          return hour >= startHour && hour < endHour;
        })
      });
    }
    return hours;
  };

  const getHourlyColor = (hourData: {hour: number, requests: any[]}) => {
    if (hourData.requests.length === 0) return '#f7fafc';
    
    // Pricing based on time blocks - simplified for demo
    const hour = hourData.hour;
    if (hour >= 18 || hour < 6) return '#f56565'; // Evening/night - high rate
    if (hour >= 12 && hour < 18) return '#f6e05e'; // Afternoon - medium rate
    return '#68d391'; // Morning - lower rate
  };

    return (<div className="ah-card ah-timeline-card" style={{ padding: 0 }}>
        <div style={{ display: 'flex', height: 400 }}>
            {/* Hour labels */}
            <div style={{ width: 60, borderRight: '1px solid var(--border)' }} className="ah-timeline-label">
            <div style={{ height: 40, borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 600, fontSize: 12 }}>
                Hour
            </div>
            {generateHourlyTimeline().map(hourData => (
                <div 
                key={hourData.hour}
                style={{ 
                    height: 15, 
                    borderBottom: '1px solid #f1f5f9', 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center',
                    fontSize: 10,
                    padding: '0 4px'
                }}
                >
                {hourData.label}
                </div>
            ))}
            </div>
            
            {/* Request timeline */}
            <div style={{ flex: 1, position: 'relative' }} className="ah-timeline-request">
            <div style={{ height: 40, borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 600, fontSize: 12 }}>
                After Hours Requests Timeline
            </div>
            
            {generateHourlyTimeline().map((hourData) => (
                <div 
                key={hourData.hour}
                style={{ 
                    height: 15,
                    borderBottom: '1px solid #f1f5f9',
                    backgroundColor: getHourlyColor(hourData),
                    position: 'relative',
                    opacity: hourData.requests.length > 0 ? 0.8 : 0.2
                }}
                >
                {hourData.requests.length > 0 && (
                    <div style={{ 
                    position: 'absolute', 
                    left: 4, 
                    top: '50%', 
                    transform: 'translateY(-50%)', 
                    fontSize: 9,
                    fontWeight: 500,
                    color: '#1a202c'
                    }}>
                    {hourData.requests.length} request{hourData.requests.length !== 1 ? 's' : ''}
                    </div>
                )}
                </div>
            ))}
            </div>
        </div>

        {/* Request details */}
        {dayDetailRequests.length > 0 && (
            <div style={{ padding: 16, borderTop: '1px solid var(--border)' }}>
            <h4 style={{ marginBottom: 12, fontSize: 14, fontWeight: 600 }}>Request Details</h4>
            <div style={{ display: 'grid', gap: 8, maxHeight: 200, overflowY: 'auto' }}>
                {dayDetailRequests.map(request => (
                <div key={request.id} style={{ 
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    alignItems: 'center',
                    padding: 8,
                    backgroundColor: '#f8f9fa',
                    borderRadius: 4,
                    fontSize: 12
                }}>
                    <div>
                    <div style={{ fontWeight: 500 }}>
                        {new Date(request.startDateTime).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})} - 
                        {new Date(request.endDateTime).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}
                    </div>
                    <div className="muted">
                        {request.areas?.join(', ') || 'No areas specified'} • {request.requesterUserId}
                    </div>
                    {request.reason && (
                        <div className="muted" style={{ fontSize: 11 }}>{request.reason}</div>
                    )}
                    </div>
                    <div style={{ 
                    padding: '4px 8px', 
                    borderRadius: 4, 
                    backgroundColor: getHourlyColor({
                        hour: new Date(request.startDateTime).getHours(),
                        requests: [request]
                    }),
                    color: 'white',
                    fontSize: 10,
                    fontWeight: 600
                    }}>
                    {new Date(request.startDateTime).getHours() >= 18 || new Date(request.startDateTime).getHours() < 6 ? 'High Rate' : 
                        new Date(request.startDateTime).getHours() >= 12 ? 'Med Rate' : 'Low Rate'}
                    </div>
                </div>
                ))}
            </div>
            </div>
        )}
        </div>)
}

export default TimelineView;